import { types, getEnv } from 'mobx-state-tree';

import { Locales, AccountModalModel, createAccountModalModel } from '@ratehub/base-ui';

import Pages from '../definitions/Pages';
import SavedDocuments from '../view-models/SavedDocuments';
import ProfileDetails from '../view-models/ProfileDetails';


const ViewStore = types
    .model({
        selectedPageModel: types.union(
            { dispatcher: snapshot => { // Either id itself or snapshot could be passed
                const id = snapshot.id ?? snapshot;
                switch (id) {
                    case Pages.myQuotes.id : return types.reference(SavedDocuments);
                    case Pages.profileDetails.id : return types.reference(ProfileDetails);
                    default : throw new Error(`ViewStore - unknown Page id: ${id}`);
                }
            } },
            types.reference(SavedDocuments),
            types.reference(ProfileDetails),
        ),

        savedDocuments: SavedDocuments,
        profileDetails: ProfileDetails,

        accountModal: AccountModalModel,

        locale: types.enumeration(Object.values(Locales)),
    })
    .views(self => ({
        get context() {
            return getEnv(self);
        },
        get selectedPageId() {
            return self.selectedPageModel?.id;
        },
    }))
    .actions(self => ({
        showMyQuotes(selectedTab) {
            if (self.context.shouldShowSignInModal) {
                self.showSignIn();
                return;
            }

            const pageModel = self.savedDocuments;

            if (self.selectedPageModel !== pageModel) {
                self.selectedPageModel = pageModel;
            }

            if (selectedTab) {
                pageModel.selectTab(selectedTab);
            }
        },
        showProfileDetails() {
            if (self.context.shouldShowSignInModal) {
                self.showSignIn();
                return;
            }

            self.selectedPageModel = self.profileDetails;
        },
        showSignUpWithLink(magicLinkToken, documentType) {
            self.accountModal.open({
                magicLinkToken,
                onSignup:  () => {
                    self.showMyQuotes();
                    self.tabs.setValue(documentType);
                },
            });
        },
        showSignIn() {
            self.accountModal.open();
        },
        closeAccountModal() {
            if (!self.context.isLoggedIn) {
                self.navigateToHomePage();
            }
        },
        navigateToHomePage() {
            document.location.href = '/';
        },
    }));

function createViewStore({ locale }, context) {
    return ViewStore.create({
        selectedPageModel: Pages.myQuotes.id, // To maintain backwards compatibility

        savedDocuments: {},
        profileDetails: {},

        accountModal: createAccountModalModel(context),

        locale,
    }, context);
}

export {
    ViewStore,
    createViewStore,
};
